var exports = {
  "a": "Box__hD-4ku",
  "w": "Box_1__TdePMN",
};

module.exports = exports;
